export const menu = {
    column1: [{
            name: "Beneficios",
            attr: {
                href: "/suscripciones/landing.html",
                "aria-label": "www.clarin.com/suscripciones/landing.html",
                target: "_blank",
            },
        },
        {
            name: "Ingresar",
            attr: {
                rel: "noopener",
                href: "https://micuenta.clarin.com/u/login/identifier?state=hKFo2SBQbXIzRVJERVlPbWJ6THRxRmZtQXFkVE1lWl9yZXVBSKFur3VuaXZlcnNhbC1sb2dpbqN0aWTZIE54N0hIUU91ZGU3dnRVOTZ6QmJVUm9GRFdzbmFmNmx4o2NpZNkgSmNWaDRUdVFpemZWWk4xUWd0bmYzY0tQNXZmWklWMms",
                "aria-label": "micuenta.clarin.com",
                target: "_blank",
            },
        },
    ],
    column2: [{
            name: "Google Play",
            attr: {
                href: "https://play.google.com/store/apps/details?id=com.agea.clarin&hl=es_AR&gl=US&pli=1",
                "aria-label": "play.google.com",
                target: "_blank",
            },
        },
        {
            name: "App Store",
            attr: {
                rel: "noopener",
                href: "https://apps.apple.com/ar/app/clar%C3%ADn-com/id597509902",
                "aria-label": "apps.apple.com/ar",
                target: "_blank",
            },
        },
    ],
    column3: [{
            name: "Últimas noticias",
            attr: {
                href: "/ultimas-noticias",
                "aria-label": "www.clarin.com/ultimas-noticias",
                target: "_blank",
            },
        },
        {
            name: "Política",
            attr: {
                rel: "noopener",
                href: "/politica",
                "aria-label": "www.clarin.com/politica",
                target: "_blank",
            },
        },
        {
            name: "Economía",
            attr: {
                rel: "noopener",
                href: "/economia",
                "aria-label": "www.clarin.com/economia",
                target: "_blank",
            },
        },
        {
            name: "Sociedad",
            attr: {
                rel: "noopener",
                href: "/sociedad",
                "aria-label": "www.clarin.com/sociedad",
                target: "_blank",
            },
        },
        {
            name: "Deportes",
            attr: {
                rel: "noopener",
                href: "/deportes",
                "aria-label": "www.clarin.com/deportes",
                target: "_blank",
            },
        },
        {
            name: "Espectáculos",
            attr: {
                rel: "noopener",
                href: "/espectaculos",
                "aria-label": "www.clarin.com/espectaculos",
                target: "_blank",
            },
        },
        {
            name: "Opinión",
            attr: {
                rel: "noopener",
                href: "/opinion",
                "aria-label": "www.clarin.com/opinion",
                target: "_blank",
            },
        },
        {
            name: "Cultura",
            attr: {
                rel: "noopener",
                href: "/cultura",
                "aria-label": "www.clarin.com/cultura",
                target: "_blank",
            },
        },
        {
            name: "Rural",
            attr: {
                rel: "noopener",
                href: "/rural",
                "aria-label": "www.clarin.com/rural",
                target: "_blank",
            },
        },
        {
            name: "Mapa del sitio",
            attr: {
                rel: "noopener",
                href: "/mapa-del-sitio",
                "aria-label": "www.clarin.com/mapa-del-sitio",
                target: "_blank",
            },
        },
    ],
    column4: [{
            name: "Clima",
            attr: {
                href: "/clima",
                "aria-label": "www.clarin.com/clima",
                target: "_blank",
            },
        },
        {
            name: "Horóscopo",
            attr: {
                rel: "noopener",
                href: "/horoscopo",
                "aria-label": "www.clarin.com/horoscopo",
                target: "_blank",
            },
        },
        {
            name: "Loterías y Quinielas",
            attr: {
                rel: "noopener",
                href: "/loterias-y-quinielas",
                "aria-label": "www.clarin.com/loterias-y-quinielas",
                target: "_blank",
            },
        },
        {
            name: "Divisas",
            attr: {
                rel: "noopener",
                href: "/economia/divisas-acciones-bonos",
                "aria-label": "www.clarin.com/economia/divisas-acciones-bonos",
                target: "_blank",
            },
        },
    ],
    column5: [{
            name: "Claringrilla",
            attr: {
                href: "/claringrilla",
                "aria-label": "www.clarin.com/claringrilla",
                target: "_blank",
            },
        },
        {
            name: "Sudoku",
            attr: {
                rel: "noopener",
                href: "/juegos/ar/sudoku/avanzado",
                "aria-label": "www.clarin.com/juegos/ar/sudoku/avanzado",
                target: "_blank",
            },
        },
        {
            name: "Lexi Reto",
            attr: {
                rel: "noopener",
                href: "/juegos/ar/lexireto",
                "aria-label": "www.clarin.com/juegos/ar/lexireto",
                target: "_blank",
            },
        },
        {
            name: "Los 8 Errores ",
            attr: {
                rel: "noopener",
                href: "/juegos/ar/diferencias",
                "aria-label": "www.clarin.com/juegos/ar/diferencias",
                target: "_blank",
            },
        },
        {
            name: "Test de Actualidad",
            attr: {
                rel: "noopener",
                href: "/juegos/ar/reto-actualidad",
                "aria-label": "www.clarin.com/juegos/ar/reto-actualidad",
                target: "_blank",
            },
        },
        {
            name: "Más",
            attr: {
                rel: "noopener",
                href: "/juegos",
                "aria-label": "www.clarin.com/juegos",
                target: "_blank",
            },
        },
    ],
    column6: [{
            name: "7 Minutos",
            attr: {
                href: "/newsletters",
                "aria-label": "www.clarin.com/newsletters",
                target: "_blank",
            },
        },
        {
            name: "Humor político",
            attr: {
                rel: "noopener",
                href: "/newsletters",
                "aria-label": "www.clarin.com/newsletters",
                target: "_blank",
            },
        },
        {
            name: "La intimidad del poder",
            attr: {
                rel: "noopener",
                href: "/newsletter/la-intimidad-del-poder",
                "aria-label": "www.clarin.com/newsletter/la-intimidad-del-poder",
                target: "_blank",
            },
        },
        {
            name: "Más",
            attr: {
                rel: "noopener",
                href: "/newsletters",
                "aria-label": "empleos.clarin.com",
                target: "_blank",
            },
        },
    ],
    column7: [{
            name: "Grupo Clarín",
            attr: {
                href: "https://grupoclarin.com",
                "aria-label": "grupoclarin.com",
                target: "_blank",
                rel: "noopener",
            },
        },
        {
            name: "Noticias Clarín",
            attr: {
                href: "/",
                "aria-label": "clarin.com",
                rel: "noopener",
            },
        },
        {
            name: "TN",
            attr: {
                href: "https://tn.com.ar",
                "aria-label": "tn.com.ar",
                target: "_blank",
                rel: "noopener",
            },
        },
        {
            name: "El Trece TV",
            attr: {
                href: "https://www.eltrecetv.com.ar",
                "aria-label": "eltrecetv.com.ar",
                target: "_blank",
                rel: "noopener",
            },
        },
        {
            name: "Mitre",
            attr: {
                href: "https://radiomitre.cienradios.com",
                "aria-label": "radiomitre.cienradios.com",
                target: "_blank",
                rel: "noopener",
            },
        },
        {
            name: "La 100",
            attr: {
                href: "https://la100.cienradios.com",
                "aria-label": "la100.cienradios.com",
                target: "_blank",
                rel: "noopener",
            },
        },
        {
            name: "Ciudad",
            attr: {
                href: "https://www.ciudad.com.ar",
                "aria-label": "ciudad.com.ar",
                target: "_blank",
                rel: "noopener",
            },
        },
        {
            name: "Cienradios",
            attr: {
                href: "https://ar.cienradios.com",
                "aria-label": "ar.cienradios.com",
                target: "_blank",
                rel: "noopener",
            },
        },
        {
            name: "La Voz del Interior",
            attr: {
                href: "https://www.lavoz.com.ar",
                "aria-label": "lavoz.com.ar",
                target: "_blank",
                rel: "noopener",
            },
        },
        {
            name: "VíaPaís",
            attr: {
                href: "https://viapais.com.ar/argentina",
                "aria-label": "viapais.com.ar",
                target: "_blank",
                rel: "noopener",
            },
        },
        {
            name: "Rumbos",
            attr: {
                href: "https://viapais.com.ar/rumbos",
                "aria-label": "viapais.com.ar",
                target: "_blank",
                rel: "noopener",
            },
        },
    ],
    column8: [{
            name: "Diario Olé",
            attr: {
                href: "https://www.ole.com.ar",
                "aria-label": "ole.com.ar",
                target: "_blank",
            },
        },
        {
            name: "Gran DT",
            attr: {
                rel: "noopener",
                href: "https://www.grandt.clarin.com",
                "aria-label": "grandt.clarin.com",
                target: "_blank",
            },
        },
        {
            name: "Argenprop",
            attr: {
                rel: "noopener",
                href: "https://www.argenprop.com",
                "aria-label": "argenprop.com",
                target: "_blank",
            },
        },
        {
            name: "Guía Clarín",
            attr: {
                rel: "noopener",
                href: "https://guia.clarin.com",
                "aria-label": "argenprop.com",
                target: "_blank",
            },
        },
        {
            name: "Clasificados",
            attr: {
                rel: "noopener",
                href: "https://clasificados.clarin.com/inicio/index#!",
                "aria-label": "clasificados.clarin.com",
                target: "_blank",
            },
        },
        {
            name: "Receptoria online",
            attr: {
                rel: "noopener",
                href: "https://receptoriaonline.clarin.com/rol/crearaviso/crear-aviso",
                "aria-label": "receptoriaonline.clarin.com",
                target: "_blank",
            },
        },
        {
            name: "Colecciones Clarín",
            attr: {
                rel: "noopener",
                href: "https://colecciones.clarin.com",
                "aria-label": "colecciones.clarin.com",
                target: "_blank",
            },
        },
        {
            name: "Elle",
            attr: {
                rel: "noopener",
                href: "https://elle.clarin.com",
                "aria-label": "elle.clarin.com",
                target: "_blank",
            },
        },
    ],
    column9: [{
        name: "Anúnciese con nosotros",
        attr: {
            href: "https://comercial.clarin.com",
            "aria-label": "Anúnciese con nosotros",
            target: "_blank",
            rel: "nofollow noopener",
        },
    }, ],
    column10: [{
            name: "Centro de Ayuda",
            attr: {
                href: "https://www.clarin.com/centro-de-ayuda.html",
                "aria-label": "clarin.com/centro-de-ayuda.html",
                rel: "noopener",
            },
        },
        {
            name: "Preguntas Frecuentes",
            attr: {
                href: "https://www.clarin.com/preguntas-frecuentes",
                "aria-label": "clarin.com/preguntas-frecuentes",
                rel: "noopener",
            },
        },
        {
            name: "Ediciones Anteriores",
            attr: {
                href: "https://www.clarin.com/ediciones-anteriores",
                "aria-label": "clarin.com/ediciones-anteriores",
                rel: "noopener",
            },
        },
    ],
};